
import { getAnalyticsTotals } from 'store/analytics/actions'
import type { GetAnalyticsTotalsDataResponse, GetAnalyticsTotalsPayload } from 'store/analytics/types'
import { useSelector } from 'store/hooks'

import type { UseQuerySelectOptions, UseQuerySelectResult } from 'hooks'

import { useQuerySelect } from 'hooks'

import {
  useAnalyticsAreaParam,
  useAnalyticsScanStatusParam,
  withAnalyticsArea,
  withAnalyticsScanStatuses,
} from './useAnalyticsAreaParam'


type UseAnalyticsParams = GetAnalyticsTotalsPayload

type UseAnalyticsResult = {
  data: GetAnalyticsTotalsDataResponse | null
} & UseQuerySelectResult<UseAnalyticsParams>

export const useAnalyticsTotals = (params: UseAnalyticsParams, options?: UseQuerySelectOptions): UseAnalyticsResult => {
  /*
    The page-global drawn area (VRG-480), merged in HERE rather than at the call site.
    See `useAnalyticsAreaParam` — the merge is inside the hook so a new analytics card
    cannot forget it, and so `useQuerySelect`'s params comparison sees the ring and
    refetches when it changes.
  */
  const areaParam = useAnalyticsAreaParam()
  /*
    The page-level SCAN OUTCOME filter (VERA-260), merged in HERE by the same mechanism
    and for the same reason as `area` — see `useAnalyticsScanStatusParam`.

    Order is fixed — scan statuses first, then area — matching every other analytics hook,
    so two hooks asking the same question cannot build two different cache keys for it.
  */
  const scanStatusParam = useAnalyticsScanStatusParam()
  const request = withAnalyticsArea(withAnalyticsScanStatuses(params, scanStatusParam), areaParam)

  const result = useQuerySelect(getAnalyticsTotals, request, options)
  const data = useSelector(state => state.analytics.totals)

  return {
    data,
    ...result,
  }
}
